import styled from 'styled-components';

import {
  CredusButton,
  color,
  CredusText,
  CredusInput,
  CredusWrapper,
  CredusAlert,
} from 'ui';
import ProfileAvatar from '../../assets/images/svgs/profile-avatar.svg';
import { AlertWrapper } from './ChangePassword';
import useProfile from './hooks/useProfile';
import { LoaderWhite } from '../../assets/images/svgs';

const Profile = () => {
  const {
    formik,
    apiError,
    data,
    isLoading,
    uploadImage,
    fileInputRef,
    handleCloseAlert,
    handleUploadClick,
    onFileChange,
  } = useProfile();
  return (
    <SubContainer>
      {apiError && (
        <AlertWrapper>
          <CredusAlert
            type="error"
            message={apiError}
            show={!!apiError}
            onCancel={handleCloseAlert}
          />
        </AlertWrapper>
      )}
      <CredusWrapper
        display="flex"
        align="flex-start"
        direction="column"
        gap=".2rem"
      >
        <AccountImage src={uploadImage || ProfileAvatar} alt="profile" />
        <UploadText onClick={handleUploadClick} size="sm" weight="medium">
          {uploadImage ? 'Change' : 'Upload'} Photo
        </UploadText>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={onFileChange}
          style={{ display: 'none' }}
        />
      </CredusWrapper>
      {data?.data && (
        <form onSubmit={formik.handleSubmit}>
          <FormDiv>
            <div>
              <CredusInput
                label="Name"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
                error={formik.touched.name ? formik.errors.name : ''}
              />
            </div>
            <div>
              <CredusInput
                label="Admin ID"
                readOnly
                name="id"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.id}
              />
            </div>
            <div>
              <CredusInput
                label="Email"
                readOnly
                name="firstName"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                error={formik.touched.email ? formik.errors.email : ''}
              />
            </div>
            <div>
              <CredusInput
                label="Phone Number"
                name="phoneNumber"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phoneNumber}
              />
            </div>
          </FormDiv>
          <BtnDiv>
            <div>
              <CredusButton
                type="submit"
                disabled={isLoading}
                variant="primary"
              >
                {isLoading ? (
                  <LoaderWhite style={{ width: 95, height: 20 }} />
                ) : (
                  'Save changes'
                )}
              </CredusButton>
            </div>
          </BtnDiv>
        </form>
      )}
    </SubContainer>
  );
};

export default Profile;

const SubContainer = styled.div`
  background: ${color.white};
  width: 75%;
  margin: auto;
`;
const FormDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2.5rem;
  margin-top: 2.5rem;
`;

const BtnDiv = styled.div`
  margin-top: 8.75rem;
`;

export const UploadText = styled(CredusText)`
  cursor: pointer;
  transition: color 0.25s ease-in-out;
  :hover {
    color: #fc391d;
  }
  :active {
    transform: translateY(1px);
  }
`;

export const AccountImage = styled.img`
  height: 104px;
  width: 104px;
  object-fit: cover;
  border-radius: 50%;
`;
